export type FileUploadFormValue = { fileId: string };

export type FileUploadValue = Array<string | FileUploadFormValue> | null | undefined;

export const toFileIds = (value?: FileUploadValue): string[] => {
  if (!value?.length) return [];

  return value.map((item) => (typeof item === 'string' ? item : item?.fileId)).filter((id): id is string => Boolean(id));
};

export const parseMaxFilesNumber = (maxFilesNumber?: number | string | null): number | null => {
  if (!maxFilesNumber && maxFilesNumber !== 0) return null;

  const parsed = Number(maxFilesNumber);
  return Number.isFinite(parsed) ? parsed : null;
};
